import React from 'react';
import { observer } from 'mobx-react';

import { frameStore } from 'apps/components/Frame/appManager';

import { Dropdown } from 'libs/rendering/gltf/components/headerDropdown';

import { UploadRevisionStyled } from './revisions.styled';

const Revisions = observer(() => {
  const { sharedFileManager } = frameStore;
  const revisionsConnection = sharedFileManager?.revisionsConn;

  return (
    <>
      {revisionsConnection?.totalCount > 1 && (
        <Dropdown
          revisionsConnection={revisionsConnection}
          selectedRevision={sharedFileManager.sharedFile?.revision}
        />
      )}
      {sharedFileManager?.sharedFile?.canUpdate &&
        !sharedFileManager?.waitingForConversion && (
          <UploadRevisionStyled
            aria-label='Upload revision'
            onClick={() => {
              sharedFileManager.OpenRevisionModal();
            }}
          >
            Upload Revision
          </UploadRevisionStyled>
        )}
    </>
  );
});

export default Revisions;
